import { forwardRef } from 'react'
import {
  ButtonStyled,
  ButtonSideLabel,
  ButtonLabel,
  LabelPrice,
  LoaderWrapper,
  LoaderIcon
} from './Button.styles'
import { ButtonProps } from './Button.types'
import { isString } from '../../../utils'
import Icon, { IIconsetMap } from '../Icon'
import Text from '../Text'

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className = '',
      label = '',
      startLabel,
      endLabel,
      disabled = false,
      styles,
      color,
      loading = false,
      loadingOpacity = 0.6,
      disabledOnLoading = false,
      startIcon,
      endIcon,
      ...props
    },
    ref
  ) => {
    const startIconElement = isString(startIcon) ? (
      <Icon name={startIcon} />
    ) : (
      startIcon
    )
    const endIconElement = isString(endIcon) ? <Icon name={endIcon} /> : endIcon
    return (
      <ButtonStyled
        className={`Button ${className}`}
        hasStartLabel={!!startLabel}
        hasEndLabel={!!endLabel}
        disabled={disabled || (loading && disabledOnLoading)}
        color={color}
        ref={ref}
        sx={styles}
        {...props}>
        {!!startLabel && (
          <ButtonSideLabel
            className="LabelStart"
            counter={startLabel.counter}
            flexDirection="column"
            sx={startLabel.styles}>
            <Text color="inherit" size="inherit" className="LabelStartContent">
              {startLabel.label}
            </Text>
            {!!startLabel.price && (
              <LabelPrice className="LabelStartContent" {...startLabel.price} />
            )}
          </ButtonSideLabel>
        )}
        <ButtonLabel className="LabelMain">
          {startIconElement}
          {label}
          {endIconElement}
        </ButtonLabel>
        {!!endLabel && (
          <ButtonSideLabel
            className="LabelEnd"
            counter={endLabel.counter}
            flexDirection="row"
            gap="8px"
            sx={endLabel.styles}>
            {endLabel.label}
            {!!endLabel.price && <LabelPrice {...endLabel.price} />}
            {!!endLabel.icon && (
              <Icon
                name={endLabel.icon}
                iconset={
                  endLabel.icon
                    .substring(0, 2)
                    .toLowerCase() as keyof IIconsetMap
                }
              />
            )}
          </ButtonSideLabel>
        )}
        <LoaderWrapper
          color={color}
          loading={loading}
          loadingOpacity={loadingOpacity}>
          <LoaderIcon />
        </LoaderWrapper>
      </ButtonStyled>
    )
  }
)

Button.displayName = 'Button'
export default Button
